import { Button, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverManagementEventsTable extends Layout {
    buttonAddDriverEvent: Button;
    sourceDriverEvents: DataSource;
    tableDriverEvents: Table;
}
